import {Component, OnInit,Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FlashMessagesService} from 'angular2-flash-messages';

import { URL_API } from '../constante';
import {Utils} from '../shared/utils';
import {Trabalho} from '../trabalho/trabalho';
import {Autor} from '../autor/autor';
import {CategoriaCientifica} from '../categoria_cientifica/categoria_cientifica';

import {CategoriaCientificaService} from '../categoria_cientifica/categoria_cientifica.service';
import {TrabalhoService} from '../trabalho/trabalho.service';
import {AcessoService} from "../acesso/acesso.service";
import {AppComponent} from "../app.component";
import {forEach} from "@angular/router/src/utils/collection";
import {Inscricao} from "../inscricao/inscricao";
import {InscricaoService} from "../inscricao/inscricao.service";
import {TrabalhoComponent} from "../trabalho/trabalho.component";
import {CadastroService} from "../cadastro/cadastro.service";
import {isNull, isUndefined} from "util";

declare var jQuery: any;

@Component({
  selector: 'app-trabalho-detail',
  templateUrl: './trabalho-detail.component.html',
  styleUrls: ['./trabalho-detail.component.css'],
    providers: [
        CategoriaCientificaService,
        TrabalhoService,
        AcessoService,
        InscricaoService,
        CadastroService
    ]
})
export class TrabalhoDetailComponent extends TrabalhoComponent implements OnInit {


    trabalho: Trabalho;
    maximo_autores: number;
    categorias: CategoriaCientifica[];
    subcategorias: CategoriaCientifica[];
    categoria_cientifica: number;
    mensagemErro: string;
    palavras_resumo: number;
    palavras_resumo_restantes: number;
    max_palavras_resumo: number;
    aplicacao: AppComponent;
    @Input('trab_id')trabalho_id:number;
    autor:Autor[];
    inscricao:Inscricao;
	unidades_executoras: string[];
	editAdmin: boolean = false;
	carregado: boolean = false;

    ngOnInit() {
        if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			this.trabalho = new Trabalho;
			this.trabalho.datas_ini = [null];
			this.trabalho.datas_fim = [null];
			this.max_palavras_resumo = 250;
			this.palavras_resumo_restantes = this.max_palavras_resumo;
			this.inscricao=new Inscricao;
			this.unidades_executoras = this.trabalhoService.unidades_executoras;
			this.trabalho.autores = [new Autor()];
			this.maximo_autores = 9;
			if(isUndefined(this.trabalho_id)|| isNull(this.trabalho_id)){
				this.route.params.subscribe(params => this.trabalho_id = +params['id']);
			}

			this.trabalhoService.getTrabalho(this.trabalho_id).then(trabalho => this.gettrab(trabalho));
			if (this.trabalho.resumo === undefined) {
				this.trabalho.resumo = '';
			}
			
			this.trabalhoService.getEtapas(this.trabalho_id).then(etapas => this.setEtapas(this.trabalho, etapas));

			this.contaPalavrasResumo();
			this.editAdmin = this.isAdmin();
		} 
    }

    link_arquivo(): string {
      return  URL_API + '/proposta/parecer/' + this.trabalho.id;
    }

    categoriasComParecer(): boolean {
      return (this.trabalho.categoria_cientifica_id == 1 || this.trabalho.categoria_cientifica_id == 2)
    }

    getcat(dados){
        this.categorias=dados;

    }
    getmod(dados){

    }
    getinst(dados){
    }
    gettrab(dados){
        this.trabalho=dados;
        this.trabalhoService.getAutores(this.trabalho_id).then(
            autores=> this.setAutores(autores));
        this.categoriaCientificaService.getcategorias()
            .then(categorias => this.getcat(categorias));
    }

    setAutores(autores){
        this.trabalho.autores = autores;
        this.trabalho.autores.forEach(function (item,index) {
           item.inst=true;
            
        })
    }

    disable(){
        jQuery("form :input").prop("disabled",true);
    }


    listarSubcategorias() {
        //seta o id do pai ao trabalho, será sobrescrito se houver um filho

        let subcategorias: CategoriaCientifica[];
        this.subcategorias = subcategorias;

        this.trabalho.categoria_cientifica_id = this.categoria_cientifica;
        // console.log(this.trabalho.categoria_cientifica_id);

        this.categoriaCientificaService.getParents(this.categoria_cientifica)
            .then(subcategorias => {
                this.subcategorias = (subcategorias.length > 0) ? subcategorias : null;
            });


    }

    adicionarAutor() {
        if (this.permiteAdicionarAutores()) {
            this.trabalho.autores.push(new Autor());
        } else {
            //console.log('Número máximo de autores atingido!');
        }
    }

    removerAutor(index) {
        if (index > -1) {
            this.trabalho.autores.splice(index, 1);
        }
    }

    permiteAdicionarAutores(): boolean {
        return (this.trabalho.autores.length < this.maximo_autores);
    }

    limparResumo(): void {
        this.trabalho.resumo = '';
        this.palavras_resumo_restantes = this.max_palavras_resumo;
    }

    contaPalavrasResumo(): void {
        this.palavras_resumo = this.trabalho.resumo.split(' ').length;
        this.restantePalavrasResumo();
		this.carregado = true;
    }

    restantePalavrasResumo(): void {
        if ((this.palavras_resumo_restantes > 0) && (this.palavras_resumo <= this.max_palavras_resumo)
        ) {
            this.palavras_resumo_restantes = this.max_palavras_resumo - this.palavras_resumo;
        }
        else {
            this.palavras_resumo_restantes = 0;
        }
    }

    resetInstituicao( autor: Autor ): void {
        autor.inst = true;
    }
	
    trim(str) {
        str=str.toLowerCase();
        return str.replace(/^\s+|\s+$/g,"");
    }


}



// WEBPACK FOOTER //
// ./src/app/trabalho-detail/trabalho-detail.component.ts